import { render, staticRenderFns } from "./BaseInputSwitch.vue?vue&type=template&id=2ea72814"
import script from "./BaseInputSwitch.vue?vue&type=script&lang=js"
export * from "./BaseInputSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports